import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** The parent component of a set of pages used to release medication for provider orders */
@Component({
  selector: 'app-release-pages',
  template: `<router-outlet />`,
  styles: [],
  standalone: true,
  imports: [
    RouterOutlet,
  ]
})
export class ReleasePagesComponent {
}
